<h4
    class="d-flex align-content-center justify-content-between"
    style="color: red"
>
    <span>Σφάλμα</span>
</h4>
<div
    *ngIf="errorMessage"
    class="qrlabel redLeftBorder w-100 qrlabel-errormessage"
>
    <span class="errormessage">{{ errorMessage }}</span>
</div>

<div
    *ngIf="errorMessages"
    class="
        qrlabel
        redLeftBorder
        w-100
        qrlabel-errormessage
        flex-column
        justify-content-center
        align-items-start
    "
>
    <ng-container *ngIf="errorMessages">
        <ng-container *ngFor="let errorMessage of errorMessages">
            <span class="errormessage" [innerHTML]="errorMessage"></span>
        </ng-container>
    </ng-container>
</div>
